// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { AlertType } from "./Shared.AlertType.gen";
import { AlertSeverity } from "./Shared.AlertSeverity.gen";
import { AlertStatus } from "./Shared.AlertStatus.gen";

/* eslint-disable @typescript-eslint/no-unused-vars */
import { IsOptional, MaxLength } from 'class-validator';

/* eslint-enable @typescript-eslint/no-unused-vars */ //JTH
export interface IAlert {
	acknowledgedByName: string | undefined;

	resolvedByName: string | undefined;

	deviceName: string | undefined;

	facilityName: string | undefined;

	organizationName: string | undefined;

	facilityTimezoneId: string | undefined;

	id: string | undefined;

	organizationId: string | undefined;

	facilityId: string | undefined;

	deviceId: string | undefined;

	alertType: AlertType;

	severity: AlertSeverity;

	status: AlertStatus;

	openedAtUtc: string | undefined;

	lastEvaluatedAtUtc: string | undefined;

	observationCount: number;

	reopenCount: number;

	lastReopenedAtUtc: string | undefined;

	acknowledgedAtUtc: string | undefined;

	acknowledgedByUserId: string | undefined;

	resolvedAtUtc: string | undefined;

	resolvedByUserId: string | undefined;

	autoResolved: boolean;

	resolveNote: string | undefined;

	message: string | undefined;

	detailsJson: string | undefined;

	$type?: string | undefined;
}
export class Alert {
	constructor(data?: IAlert) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.openedAtUtc) { this.openedAtUtc = new Date(data.openedAtUtc); }
		if (data.lastEvaluatedAtUtc) { this.lastEvaluatedAtUtc = new Date(data.lastEvaluatedAtUtc); }
		if (data.lastReopenedAtUtc) { this.lastReopenedAtUtc = new Date(data.lastReopenedAtUtc); }
		if (data.acknowledgedAtUtc) { this.acknowledgedAtUtc = new Date(data.acknowledgedAtUtc); }
		if (data.resolvedAtUtc) { this.resolvedAtUtc = new Date(data.resolvedAtUtc); }
	}

	acknowledgedByName: string | undefined;

	resolvedByName: string | undefined;

	deviceName: string | undefined;

	facilityName: string | undefined;

	organizationName: string | undefined;

	facilityTimezoneId: string | undefined;

	id: string | undefined;

	organizationId: string | undefined;

	facilityId: string | undefined;

	deviceId: string | undefined;

	alertType: AlertType = 0;

	severity: AlertSeverity = 0;

	status: AlertStatus = 0;

	openedAtUtc: Date | undefined = new Date();

	lastEvaluatedAtUtc: Date | undefined = new Date();

	observationCount: number = 0;

	reopenCount: number = 0;

	lastReopenedAtUtc: Date | undefined;

	acknowledgedAtUtc: Date | undefined;

	acknowledgedByUserId: string | undefined;

	resolvedAtUtc: Date | undefined;

	resolvedByUserId: string | undefined;

	autoResolved: boolean = false;

	resolveNote: string | undefined;

	@IsOptional()
	@MaxLength(512)
	message: string | undefined;

	detailsJson: string | undefined;

	static $type: string = "CoreApi.Models.Alerts.Alert, ";
	$type?: string | undefined = Alert.$type;
}

